var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-2" }, [
        _c("h3", [_vm._v("Cap Details")]),
      ]),
      _c("base-form", {
        ref: "capFormRef",
        on: { submit: _vm.saveCap },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cap Title",
                            value: _vm.capForm.title,
                            rules: "required",
                            placeholder: "Enter cap title",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.capForm, "title", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-select", {
                          attrs: {
                            label: "Cap Direction",
                            value: _vm.capForm.capDirection,
                            items: _vm.capDirections,
                            "item-text": "value",
                            "item-value": "key",
                            rules: "required",
                            placeholder: "Select cap direction",
                            readonly: "",
                            disabled: "",
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.capForm,
                                "capDirection",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-autocomplete", {
                          attrs: {
                            label: "Protection Type",
                            value: _vm.capForm.protectionType,
                            items: _vm.protectionTypes,
                            "item-text": "value",
                            "item-value": "key",
                            rules: "required",
                            multiple: true,
                            "return-object": false,
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.capForm,
                                "protectionType",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-select", {
                          attrs: {
                            label: "Cable Entry Type",
                            value: _vm.capForm.cableEntryType,
                            items: _vm.cableEntryTypes,
                            "item-text": "value",
                            "item-value": "key",
                            rules: "required",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.capForm,
                                "cableEntryType",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Model No",
                            value: _vm.capForm.modelNo,
                            placeholder: "Enter model number",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.capForm, "modelNo", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Certification No",
                            value: _vm.capForm.certificationNo,
                            placeholder: "Enter certification number",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.capForm,
                                "certificationNo",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Manufacturer",
                            value: _vm.capForm.manufacturer,
                            placeholder: "Enter manufacturer name",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.capForm,
                                "manufacturer",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Serial No",
                            value: _vm.capForm.serialNo,
                            placeholder: "Enter serial number",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.capForm, "serialNo", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.readonly
                  ? _c(
                      "v-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  color: "grey",
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v("Reset")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  type: "submit",
                                  loading: _vm.isLoading,
                                  disabled: invalid,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEditing
                                        ? "Update Cap"
                                        : "Create Cap"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }